'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactCustomScrollbars = require('react-custom-scrollbars');

var _reactAutocomplete = require('react-autocomplete');

var _reactAutocomplete2 = _interopRequireDefault(_reactAutocomplete);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _throttleDebounce = require('throttle-debounce');

var _throttleDebounce2 = _interopRequireDefault(_throttleDebounce);

var _onEscape = require('utils/onEscape');

var _onEscape2 = _interopRequireDefault(_onEscape);

var _components = require('components');

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BACKSPACE = 8;
var ESCAPE = 27;
var RETURN = 13;

var typeOptions = [{ value: 'everything', to: '/megascans/types/everything', name: 'All types' }, { value: 'atlas', to: '/megascans/types/atlas', name: 'Atlases' }, { value: 'surface', to: '/megascans/types/surface', name: 'Surfaces' }, { value: '3d', to: '/megascans/types/3d', name: '3D' }, { value: '3dplant', to: '/megascans/types/3dplant', name: '3D Plants' }];

function renderItem(item, highlighted) {
  var styles = require('./SearchField.scss');

  return _react2.default.createElement(
    'div',
    { className: styles.suggestion + (highlighted ? ' ' + styles.suggestionFocused : '') },
    _react2.default.createElement(
      'span',
      { className: styles.suggestionText },
      item.tag
    )
  );
}

function renderItems(items, fetchingSuggestions) {
  var styles = require('./SearchField.scss');

  return items.length ? items : fetchingSuggestions ? null : _react2.default.createElement(
    'div',
    { className: styles.nothingFound },
    'Try searching for something else?'
  );
}

function renderMenu(items, value, fetchingSuggestions, style) {
  var styles = require('./SearchField.scss');

  var renderThumbVertical = function renderThumbVertical() {
    return _react2.default.createElement('div', { style: {
        background: '#000',
        borderRadius: '4px',
        width: '8px',
        display: 'block',
        border: '1px solid #c6c6c6'
      } });
  };

  return !value.length ? _react2.default.createElement(
    'span',
    null,
    _react2.default.createElement('span', null)
  ) : _react2.default.createElement(
    'div',
    { className: styles.suggestionsContainer },
    _react2.default.createElement(
      _reactCustomScrollbars.Scrollbars,
      { universal: true, autoHeight: true, autoHide: true, renderThumbVertical: renderThumbVertical },
      _react2.default.createElement(
        'div',
        { className: styles.suggestionsWrap },
        renderItems(items, fetchingSuggestions)
      )
    )
  );
}

var SearchField = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(SearchField, _React$Component);

  function SearchField(props) {
    (0, _classCallCheck3.default)(this, SearchField);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SearchField.__proto__ || (0, _getPrototypeOf2.default)(SearchField)).call(this));

    _this.propsOnChange = props.onChange && _throttleDebounce2.default.throttle(200, props.onChange);

    _this.state = {
      value: props.initialValue || ''
    };
    return _this;
  }

  (0, _createClass3.default)(SearchField, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _props = this.props,
          onSearchCancel = _props.onSearchCancel,
          isSearchActive = _props.isSearchActive;


      if (isSearchActive) {
        onSearchCancel();
        (0, _onEscape2.default)('searchField');
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!this.props.isSearchActive && nextProps.isSearchActive) {
        (0, _onEscape2.default)('searchField', nextProps.onSearchCancel);
      }

      if (this.props.isSearchActive && !nextProps.isSearchActive) {
        (0, _onEscape2.default)('searchField');
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(event, _ref) {
      var newValue = _ref.newValue,
          method = _ref.method;

      this.setState({
        value: newValue
      });
    }
  }, {
    key: 'onSuggestionSelected',
    value: function onSuggestionSelected(suggestion) {
      var _props2 = this.props,
          onSearch = _props2.onSearch,
          tags = _props2.tags;

      onSearch(tags.concat(suggestion));

      this.setState({
        value: ''
      });
    }
  }, {
    key: 'loseFocus',
    value: function loseFocus() {
      document.getElementById('site-search').blur();
    }
  }, {
    key: 'onValueChanged',
    value: function onValueChanged(ev, value) {
      var onChange = this.props.onChange;


      this.setState({ value: value });

      if (this.propsOnChange) {
        this.propsOnChange(value);
      }
    }
  }, {
    key: 'onInputFocus',
    value: function onInputFocus() {
      var onSearchFocusChange = this.props.onSearchFocusChange;


      if (onSearchFocusChange) {
        onSearchFocusChange(true);
      }

      this.setState({ focused: true });
    }
  }, {
    key: 'onInputBlur',
    value: function onInputBlur() {
      var onSearchFocusChange = this.props.onSearchFocusChange;


      if (onSearchFocusChange) {
        onSearchFocusChange(false);
      }

      this.setState({ focused: false });
    }
  }, {
    key: 'shouldItemRender',
    value: function shouldItemRender(item, value) {
      return item && item.tag.indexOf(value) > -1;
    }
  }, {
    key: 'sortItems',
    value: function sortItems(a, b, value) {
      return a.tag.indexOf(value) > b.tag.indexOf(value) ? 1 : -1;
    }
  }, {
    key: 'onKeyDown',
    value: function onKeyDown(ev) {
      var _this2 = this;

      if (ev.keyCode == BACKSPACE) {
        if (!this.state.value.length) {
          var _props3 = this.props,
              onSearch = _props3.onSearch,
              tags = _props3.tags;

          onSearch(tags.slice(0, -1));
        }
      }

      if (ev.keyCode == ESCAPE) {
        var onSearchCancel = this.props.onSearchCancel;

        onSearchCancel();
        document.getElementById('site-search').blur();
      }

      if (ev.keyCode == RETURN) {
        setTimeout(function () {
          if (_this2.state.value.length) {
            var _props4 = _this2.props,
                _onSearch = _props4.onSearch,
                _tags = _props4.tags;

            _onSearch(_tags.concat(_this2.state.value));

            _this2.setState({ value: '' });
            document.getElementById('site-search').blur();
          }
        }, 10);
      }
    }
  }, {
    key: 'onSearchTagClicked',
    value: function onSearchTagClicked(ev, tag) {
      var _props5 = this.props,
          onSearch = _props5.onSearch,
          tags = _props5.tags;

      onSearch(_underscore2.default.without(tags, tag));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this,
          _classnames;

      var _props6 = this.props,
          autoFocus = _props6.autoFocus,
          placeholder = _props6.placeholder,
          suggestions = _props6.suggestions,
          fetchingSuggestions = _props6.fetchingSuggestions,
          isSearchActive = _props6.isSearchActive,
          onSearchCancel = _props6.onSearchCancel,
          tags = _props6.tags,
          currentType = _props6.currentType;
      var _state = this.state,
          value = _state.value,
          focused = _state.focused,
          editorState = _state.editorState;


      var styles = require('./SearchField.scss');

      var inputProps = {
        id: 'site-search',
        className: tags.length ? styles.input + ' ' + styles['input--searching'] : styles.input,
        placeholder: placeholder,
        type: 'search',
        autoFocus: autoFocus
      };

      var onSearchTagClicked = function onSearchTagClicked(t) {
        return function (ev) {
          return _this3.onSearchTagClicked(ev, t);
        };
      };

      var classes = (0, _classnames3.default)((_classnames = {}, (0, _defineProperty3.default)(_classnames, styles.SearchField, true), (0, _defineProperty3.default)(_classnames, styles['SearchField--focused'], focused), _classnames));

      var transitionName = {
        enter: styles['SearchTag-enter'],
        enterActive: styles['SearchTag-enter-active'],
        leave: styles['SearchTag-leave'],
        leaveActive: styles['SearchTag-leave-active']
      };

      return _react2.default.createElement(
        'div',
        {
          className: classes,
          onKeyDown: this.onKeyDown.bind(this) },
        _react2.default.createElement(
          'div',
          { className: styles.SearchField__typeSelector },
          _react2.default.createElement(_components.SearchFieldTypeSelector, { value: currentType, options: typeOptions })
        ),
        _react2.default.createElement(
          'div',
          { className: styles.SearchTagsWrapper },
          _react2.default.createElement(
            'div',
            { className: styles.SearchTags },
            tags.map(function (t, i) {
              return _react2.default.createElement(
                'span',
                { className: styles.SearchTagContainer, key: t },
                _react2.default.createElement(
                  'span',
                  { className: styles.SearchTag, onClick: onSearchTagClicked(t) },
                  t
                )
              );
            })
          )
        ),
        _react2.default.createElement(
          'span',
          {
            onFocus: this.onInputFocus.bind(this),
            onBlur: this.onInputBlur.bind(this) },
          _react2.default.createElement(_reactAutocomplete2.default, {
            value: value,
            wrapperProps: { className: styles.container },
            inputProps: inputProps,
            shouldItemRender: this.shouldItemRender,
            sortItems: this.sortItems,
            onChange: this.onValueChanged.bind(this),
            onSelect: this.onSuggestionSelected.bind(this),
            renderItem: renderItem,
            renderMenu: _underscore2.default.partial(renderMenu, _underscore2.default, _underscore2.default, fetchingSuggestions),
            getItemValue: function getItemValue(i) {
              return i.tag;
            },
            items: suggestions })
        ),
        isSearchActive || tags.length ? _react2.default.createElement(
          'div',
          { className: styles.SearchField__cancel, onClick: onSearchCancel },
          '\xD7'
        ) : null
      );
    }
  }]);
  return SearchField;
}(_react2.default.Component), _class.propTypes = {
  placeholder: _react2.default.PropTypes.string,
  suggestions: _react2.default.PropTypes.array
}, _class.defaultProps = {
  placeholder: 'Search...',
  suggestions: []
}, _temp);
exports.default = SearchField;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SearchField/SearchField.jsx
// module id = 2663
// module chunks = 0